import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonData } from '../../../shared/public-api';

@Component({
  selector: 'admin-button-section',
  imports: [CommonModule, FormsModule, InputTextModule],
  templateUrl: './button-section.component.html',
  styleUrl: './button-section.component.scss',
})
export class ButtonSectionComponent implements OnInit {
  @Input() sectionData: ButtonData;
  @Output() sectionDataChange = new EventEmitter<any>();

  ngOnInit(): void {
    if (!this.sectionData) {
      this.sectionData = new ButtonData();
      this.sectionData.icon = '/admin-icons/tickets.svg';
    }
  }
}
